export default {
  global: {
    action: 46254, // Action
    actionUndone: 101719, // Action Undone
    actions: 80921, // Action
    add: 57252, // Add
    addANote: 100543, // Add a note
    advanced: 84780, // Advanced
    all: 45863, // All
    amount: 46251, // Amount
    applyChanges: 101471, // Apply Changes
    asOfDate: 101578, // As of {date}
    asOfToday: 101726, // As of today
    availability: 91203, // Availability
    balance: 46252, // Balance
    cancel: 57057, // Cancel
    category: 102231, // Category
    changesYouMadeMayNotBeSaved: 101704, // Changes you made may not be saved.
    clear: 80404, // Clear
    close: 46349, // Close
    comment: 46041, // Comment
    completed: 102253, // Completed
    confirm: 102401, // Confirm
    continue: 101636, // Continue
    current: 84208, // Current
    currentMonth: 101551, // Current month
    currentWeek: 95828, // Current Week
    date: 45108, // Date
    dateFutureOnly: 101438, // Date (Future Only)
    datePastOnly: 101437, // Date (Past Only)
    datesCannotOverlap: 102109, // Dates cannot overlap
    dayS: 46224, // Day(s)
    days: 45902, // days
    delete: 63103, // Delete
    deleteAll: 100981, // Delete All
    download: 100150, // Download
    draganddropFileOrBrowseComputer: 101996, // Drag-and-drop file, or browse computer
    duration: 63136, // Duration
    edit: 70000, // Edit
    editNote: 102236, // Edit Note
    end: 91578, // End
    endDate: 45475, // End Date
    endTime: 91207, // End Time
    filters: 101661, // Filters
    friday: 81290, // Friday
    from: 45645, // From
    fullList: 102212, // Full List
    haveSomethingToSayAddItHere: 101839, // Have something to say? Add it here
    headsUp: 101521, // Heads Up!
    hi: 101560, // Hi
    hide: 80706, // Hide
    job1: 57110, // Job 1 NOTE: Actual localization value is defined per customer (e.g. Customer)
    job2: 57111, // Job 2 NOTE: See job1
    job3: 57112, // Job 3 NOTE: See job1
    job4: 57113, // Job 4 NOTE: See job1
    job5: 57114, // Job 5 NOTE: See job1
    job6: 57115, // Job 6 NOTE: See job1
    jobs: 63100, // Jobs
    lastMonth: 101552, // Last month
    lastWeek: 101533, // Last Week
    length: 46005, // Length
    loading: 101894, // Loading
    logout: 81401, // Logout
    medium: 91910, // Medium
    monday: 81286, // Monday
    month: 46008, // Month
    next: 46554, // Next
    nextMonth: 101555, // Next Month
    nextWeek: 101554, // Next Week
    no: 90672, // No
    noData: 101543, // No data
    noDataYet: 101542, // No data yet
    noOptions: 101416, // No options
    noRecordsFound: 101708, // No Records Found
    none: 57094, // None
    note: 46263, // Note
    noteHasReachedCharacterLimit: 101840, // Note has reached character limit
    nothingToShow: 101423, // Nothing to show!
    off: 101502, // OFF
    ok: 82006, // Ok
    okay: 101452, // Okay!
    on: 101501, // ON
    oopsAnErrorOccurred: 101515, // Oops! An error occurred. Please try again later.
    oopsAnErrorOccurredWhileProcessingYourRequest: 101422, // Oops! An error occurred while processing your request. Please try again later.
    oopsYouDontHavePermissionToAccessThisResource: 101707, // Oops! You don’t have permission to access this resource.
    open: 101796, // Open
    past: 101205, // Past
    pleaseContactYourSystemAdministrator: 95083, // Please contact your system administrator
    previous: 91740, // Previous
    range: 101429, // Date range:
    recents: 102211, // Recents
    remove: 63222, // Remove
    requiredField: 95121, // Required Field
    reset: 91895, // Reset
    saturday: 81291, // Saturday
    save: 63056, // Save
    search: 81319, // Search
    seeMore: 101548, // See more...
    select: 57320, // Select
    selectOrSearchValue: 101415, // Select, or search value
    selectValueOrSearchValue: 101415, // Select, or search value
    show: 80103, // Show
    showAll: 101434, // Show All (Default)
    showFutureOnly: 101436, // Show Future Only
    showPastOnly: 101435, // Show Past Only
    sortBy: 101428, // Sort By
    sortByLatestToOldest: 101432, // Date: Latest to oldest date (Default)
    sortByOldestToLatest: 101433, // Date: Oldest to latest
    start: 91577, // Start
    startDate: 45095, // Start date
    startTime: 91206, // Start Time
    status: 46200, // Status
    strong: 101495, // Strong
    subject: 45113, // Subject
    summary: 81621, // Summary
    sunday: 81285, // Sunday
    thereWereNoRecordsFoundBasedOnTheGivenFilters: 101709, // There were no records found based on the given filters.
    thursday: 81289, // Thursday
    to: 45646, // To,
    today: 95119, // Today
    total: 100142, // Total
    tuesday: 81287, // Tuesday
    type: 204, // Type
    uhOh: 101588, // Uh-oh!
    unableToDownload: 102591, // Unable to download
    undo: 101705, // Undo
    upload: 80953, // Upload
    uploadingFile: 101994, // Uploading file
    version: 80836, // Version
    view: 63223, // View
    weak: 101494, // Weak
    wednesday: 81288, // Wednesday
    yes: 57058, // Yes
    yesImSure: 101440, // Yes I'm Sure
    yesterday: 95118, // Yesterday
  },
};
